import React from 'react';
import { Clock3Icon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencySection() {
  return <section className="bg-[#241622] px-5 py-16" data-id="element-283" data-mp="2sk46nkhn1yb1">
      <div className="mx-auto max-w-2xl rounded-3xl border-2 border-[#d770ae] bg-[#38233c] p-8 text-center sm:p-11" data-id="element-284" data-mp="369pi89t3zb91">
        <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.2em] text-[#f4b4d8]" data-id="element-285" data-mp="31iz8kkdngm8j">
          <Clock3Icon className="h-4 w-4" data-id="element-286" data-mp="3g6u3m7f4r2os" />
          Offerta a tempo limitato
        </p>
        <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-none text-white sm:text-5xl" data-id="element-287" data-mp="3b7zcmi70e7tl">
          Il prezzo di lancio scade tra:
        </h2>
        <div className="my-9" data-id="element-288" data-mp="3l78c1qkn8enc">
          <CountdownTimer size="large" dark data-id="element-289" data-mp="3l6yjbv87rtdy" />
        </div>
        <p className="font-semibold text-white" data-id="element-290" data-mp="3l5doe4hzm8fk">
          Dopo, il prezzo aumenterà di €5 e non scenderà mai più.
        </p>
        <div className="mx-auto mt-7 max-w-sm" data-id="element-291" data-mp="1qtp7hws73vsj">
          <div className="h-3 overflow-hidden rounded-full border border-[#d770ae]/50 bg-[#140c16]" data-id="element-292" data-mp="1qv0bnxpjz5k6">
            <div className="h-full w-[72%] bg-[#c02970]" data-id="element-293" data-mp="2srl9egl6jtw0" />
          </div>
          <div className="mt-3 flex justify-between text-[10px] font-bold uppercase tracking-widest" data-id="element-294" data-mp="2xtj2e2jdu325">
            <span className="text-[#f4b4d8]" data-id="element-295" data-mp="32r2g91c64dtk">
              Disponibilità limitata — solo per oggi
            </span>
            <span className="text-slate-300" data-id="element-296" data-mp="37jvldqbjto66">72% riscattato</span>
          </div>
        </div>
      </div>
    </section>;
}